export const getStudyPlanStatusColor = (status) => {
  switch (status) {
    case true:
      return 'success';
    case false:
      return 'inverse';
    default:
      return 'inverse';
  }
};